/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m14.174 10.9375c0 .414-.336.75-.75.75h-1.179v1.06c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.06h-1.177c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h1.177v-1.06c0-.414.336-.75.75-.75s.75.336.75.75v1.06h1.179c.414 0 .75.336.75.75zm-9.171-1.913c.414 0 .75.336.75.75s-.336.75-.75.75h-1.761c-.414 0-.75-.336-.75-.75s.336-.75.75-.75zm2.934-.525h-4.695c-.414 0-.75-.335-.75-.75 0-.414.336-.75.75-.75h4.695c.414 0 .75.336.75.75 0 .415-.336.75-.75.75zm5.639-6.5c1.061 0 1.924.851 1.924 1.897v4.82c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-2.684h-12v5.571c0 .219.19.396.424.396h5.456c.414 0 .75.336.75.75 0 .415-.336.751-.75.751h-5.456c-1.061 0-1.924-.851-1.924-1.897v-7.707c0-1.046.863-1.897 1.924-1.897zm-11.576 2.533h12v-.636c0-.219-.19-.396-.424-.396h-11.152c-.234 0-.424.177-.424.396z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;